<template>
  <div class="home_lump">

    <div v-if="tipPopFlag" class="tip_pop">
      <div class="content_lump">
                <span>
                    <h5>提示</h5>
                    为了保证交易安全，请先完成实名认证后再继续操作
                </span>

        <span class="btn_lump">
          <img src="../../static/img/close_white.png" @click="tipPopFlag=false">
        </span>

        <div class="btn_sure" @click="tipPopFlag=false">确定</div>
      </div>
    </div>

    <div class="top_lump">
      <div>
        <img src="../../static/img/logo2.png" @click="goto('home')">
<!--        <h5>JIN YUN</h5>-->
      </div>
      <div v-if="userInfo!==null">
<!--        <h5>永久网址：99.com</h5>-->
        <img @click="goto('message')" src="../../static/img/icon_msg.png">
        <span v-if="messageUnreadCount>0" style="color: red;">{{messageUnreadCount}}</span>
      </div>
      <div v-else>
        <div class="login_btn">
          <div @click="goto('login')">登录</div>
          <div @click="goto('sign')">注册</div>
        </div>
      </div>
    </div>


    <div class="swiper_lump">
      <swiper v-if="bannerList.length>0" :options="swiperOption" class="bannerSwiper" ref="bannerSwiper"
              style="text-align: center">

        <swiper-slide v-for="(ele,index) in bannerList" :key="index">
          <img :src="ele['image']" @click="loca(ele)"/>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination"></div>
    </div>

    <div class=attention>
      <div class=con>
        <Marquee :attention="attention"/>
      </div>
    </div>

    <div class="game_lump_01">
        <span @click="goto('hot')">
          <img src="../../static/img/game_recommend.png">
        </span>
      <span @click="goto('live')">
          <img src="../../static/img/game_live.png">
        </span>
    </div>

    <div class="game_lump_02">
        <span @click="goto('sports')">
          <img src="../../static/img/game_sports.png">
        </span>
    </div>

    <div class="game_lump_03">
        <span @click="goto('chess')">
          <img src="../../static/img/game_chess.png">
        </span>
      <span @click="goto('slot')">
          <img src="../../static/img/game_slots.png">
        </span>
      <span @click="goto('lottery')">
          <img src="../../static/img/game_lottery.png">
        </span>
    </div>

    <div class="game_lump_02">
        <span @click="goto('fish')">
          <img src="../../static/img/game_fish.png">
        </span>
    </div>

    <div class="footer_bottom_information">
      <p>
        注册公司地址:Hillside (直布罗陀) 有限公司<br>
        Unit 1.1, First Floor, Waterport Place, 2 Europort Avenue, Gibraltar. Hillside (直布罗陀) 有限公司 由直布罗陀执照局颁发执照，<br>
        并受直布罗陀博彩委员会监管。<br>
<!--        <span @click="goto('agentJoin')">代理加盟</span>-->
      </p>
      <p><a style="text-decoration: underline;color: red;" href="https://aff.jinyunjy.com/agent/home/index.html" target="_blank">代理加盟</a></p>
      <img src="../../static/img/footer_logo.png">
      <p>©2001-2030 金运集团 版权所有</p>
    </div>


  </div>

</template>

<script>

import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import Marquee from "@/components/marquee/marquee.vue";

import {
  createSystemAnnounce,
  createBanner,
  createUserInfo, createMessageUnreadCount, createGamePlatform
} from '../../xhr'
import {
  getSystemAnnounceStorage,
  getClearToken,
  getRequestArgsCrypto,
  getUserInfoStorage,
  setStorage
} from "@/util";


export default {
  components: {
    swiper,
    swiperSlide,
    Marquee
  },
  data() {
    return {
      serviceAddress: null,
      userInfo: null,
      messageUnreadCount: 0,
      systemAnnounce: null,
      bannerList: [],
      peopleType: null,
      tipPopFlag: false,
      swiperOption: {
        loop: true,  // 是否循环轮播
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,    // 用户操作swiper之后，是否禁止autoplay
        },
        autoHeight: true,
        // slidesPerView: 5,  // 可是区域内可展示多少个块
        // spaceBetween: 30,  // 块之间间隔距离
        initialSlide: 0,  // 默认初始显示块
        freeMode: false,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,   // 修改swiper父元素时，自动初始化swiper
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      attention: [],
    }
  },
  methods: {
    goto(address, peopleType) {
      this.peopleType = peopleType
      if (this.userInfo === null && address !== 'home' && address !== 'login' && address !== 'sign') {
        this.$message({message: '请先登录', type: 'error'})
        this.$router.push({path:'/login'})
      } else {
        this.$router.push({name: address, query: {peopleType}})
      }
    },

    loca(e){
      location.href = e.url
    },
    // 获取用户信息
    getUserInfo() {
      const data = '{}';
      const requestCryptoObj = getRequestArgsCrypto(data)
      const obj = {
        nonce: requestCryptoObj.nonce,
        timestamp: requestCryptoObj.timestamp,
        content: requestCryptoObj.content,
        sign: requestCryptoObj.sign
      }
      createUserInfo(obj, requestCryptoObj.secretKey).then(res => {
        if (res['code'] === 200) {
          setStorage('userInfo', res['data'])
          this.userInfo = getUserInfoStorage()
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取系统公告
    getSystemAnnounce() {
      const data = '{}';
      const requestCryptoObj = getRequestArgsCrypto(data)
      const obj = {
        nonce: requestCryptoObj.nonce,
        timestamp: requestCryptoObj.timestamp,
        content: requestCryptoObj.content,
        sign: requestCryptoObj.sign
      }
      createSystemAnnounce(obj, requestCryptoObj.secretKey).then(res => {
        if (res['code'] === 200) {
          setStorage('systemAnnounce', res['data']['list'])
          this.systemAnnounce = res['data']['list']
          this.systemAnnounce.forEach(ele => {
            this.attention.push(
                {title: ele['content']}
            )
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取消息未读条数
    getMessageUnreadCount() {
      const data = '{}';
      const requestCryptoObj = getRequestArgsCrypto(data)
      const obj = {
        nonce: requestCryptoObj.nonce,
        timestamp: requestCryptoObj.timestamp,
        content: requestCryptoObj.content,
        sign: requestCryptoObj.sign
      }
      createMessageUnreadCount(obj, requestCryptoObj.secretKey).then(res => {
        if (res['code'] === 200) {
          this.messageUnreadCount = res['data']['count']
        }
      }).catch(err => {
        console.log(err)
      })
    },

    getBanner() {
      const data = '{}';
      const requestCryptoObj = getRequestArgsCrypto(data)
      const obj = {
        nonce: requestCryptoObj.nonce,
        timestamp: requestCryptoObj.timestamp,
        content: requestCryptoObj.content,
        sign: requestCryptoObj.sign
      }
      createBanner(obj, requestCryptoObj.secretKey).then(res => {
        if (res['code'] === 200) {
          this.bannerList = res['data']['list']
          console.log(this.bannerList)
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },
  created() {
    this.userInfo = getUserInfoStorage()
    this.getBanner()
    this.getUserInfo()
    this.getSystemAnnounce()
    this.getMessageUnreadCount()
  }
}
</script>

<style lang="less">
@import "home.less";
</style>
<style>
.swiper-pagination {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: .12rem;
  margin: auto;
}

.swiper-container {
  border-radius: .1rem;
  overflow: hidden;
}

.swiper-pagination-bullet {
  width: .12rem;
  height: .06rem;
  opacity: 1;
  background: #ECECEC;
  margin: 0 0.04rem;
  border-radius: .03rem;
}

.swiper-pagination-bullet-active {
  width: .24rem;
  height: .06rem;
  opacity: 1;
  background: #ECECEC;
}
</style>
